export const assetList =
  [
    {
      "uid": 1,
      "filename": "fb9c9ef6-eb91-4148-9bb3-f5cdcde2e430.png",
      "itemName": "Soccer Field",
      "category": "Sports",
      "isApplicable": true
    },
    {
      "uid": 2,
      "filename": "4a3d8029-6345-4891-ac06-7d8b39b80379_2.png",
      "itemName": "Concession Stand",
      "category": "Community",
      "isApplicable": false
    },
    {
      "uid": 3,
      "filename": "4a3d8029-6345-4891-ac06-7d8b39b80379_3.png",
      "itemName": "Concession Stand",
      "category": "Community",
      "isApplicable": true
    },
    {
      "uid": 4,
      "filename": "31e8e5c5-1610-43bd-9d9f-1c1d4c3e7ee4_2.png",
      "itemName": "Dog Park",
      "category": "Community",
      "isApplicable": true
    },
    {
      "uid": 5,
      "filename": "88b9ae89-c7c8-4776-8743-2ee865774269_1.png",
      "itemName": "Dog Park",
      "category": "Community",
      "isApplicable": false
    },
    {
      "uid": 6,
      "filename": "bf98aa9d-2100-4bff-b1e0-54f1c5d40af0_0.png",
      "itemName": "Farmers Market",
      "category": "Community",
      "isApplicable": true
    },
    {
      "uid": 7,
      "filename": "bf98aa9d-2100-4bff-b1e0-54f1c5d40af0_1.png",
      "itemName": "Farmers Market",
      "category": "Community",
      "isApplicable": false
    },
    {
      "uid": 8,
      "filename": "099dfb58-bdf6-4e54-802b-0285d78dbb88_0.png",
      "itemName": "Fountain",
      "category": "Community",
      "isApplicable": false
    },
    {
      "uid": 9,
      "filename": "099dfb58-bdf6-4e54-802b-0285d78dbb88_1.png",
      "itemName": "Fountain",
      "category": "Community",
      "isApplicable": false
    },
    {
      "uid": 10,
      "filename": "099dfb58-bdf6-4e54-802b-0285d78dbb88_2.png",
      "itemName": "Fountain",
      "category": "Community",
      "isApplicable": true
    },
    {
      "uid": 11,
      "filename": "099dfb58-bdf6-4e54-802b-0285d78dbb88_3.png",
      "itemName": "Fountain",
      "category": "Community",
      "isApplicable": false
    },
    {
      "uid": 12,
      "filename": "5bea98cd-1991-47de-98b2-4a3d84085541_1.png",
      "itemName": "Kayak Stand",
      "category": "Sports",
      "isApplicable": false
    },
    {
      "uid": 13,
      "filename": "c43f6a17-415e-42ff-a67e-0ea8d57a7ee0_0.png",
      "itemName": "Kayak Stand",
      "category": "Sports",
      "isApplicable": true
    },
    {
      "uid": 14,
      "filename": "c43f6a17-415e-42ff-a67e-0ea8d57a7ee0_1.png",
      "itemName": "Kayak Stand",
      "category": "Sports",
      "isApplicable": false
    },
    {
      "uid": 15,
      "filename": "ccb74137-e7b5-4b50-80cb-103b20978014_0.png",
      "itemName": "Kiosk",
      "category": "Community",
      "isApplicable": false
    },
    {
      "uid": 16,
      "filename": "ccb74137-e7b5-4b50-80cb-103b20978014_1.png",
      "itemName": "Kiosk",
      "category": "Community",
      "isApplicable": false
    },
    {
      "uid": 17,
      "filename": "ccb74137-e7b5-4b50-80cb-103b20978014_2.png",
      "itemName": "Kiosk",
      "category": "Community",
      "isApplicable": false
    },
    {
      "uid": 18,
      "filename": "a91165e6-4f77-4e0d-985c-a1ec6a171348.png",
      "itemName": "Kiosk",
      "category": "Community",
      "isApplicable": true
    },
    {
      "uid": 19,
      "filename": "e7446d46-1299-4138-ae8c-97fc5f2884ae.png",
      "itemName": "Kiosk",
      "category": "Community",
      "isApplicable": false
    },
    {
      "uid": 20,
      "filename": "e60f7bee-dfea-4659-9138-8a3e7d62c5a4_3.png",
      "itemName": "Pavillion",
      "category": "Community",
      "isApplicable": true
    },
    {
      "uid": 21,
      "filename": "da362894-37a1-467a-b635-435adc9009bf_2.png",
      "itemName": "Playground",
      "category": "Family",
      "isApplicable": true
    },
    {
      "uid": 22,
      "filename": "37d2437b-33f3-4cb9-ad08-cf8d4010af27_0.png",
      "itemName": "Public Art",
      "category": "Community",
      "isApplicable": false
    },
    {
      "uid": 23,
      "filename": "37d2437b-33f3-4cb9-ad08-cf8d4010af27_1.png",
      "itemName": "Public Art",
      "category": "Community",
      "isApplicable": true
    },
    {
      "uid": 24,
      "filename": "37d2437b-33f3-4cb9-ad08-cf8d4010af27_2.png",
      "itemName": "Public Art",
      "category": "Community",
      "isApplicable": false
    },
    {
      "uid": 25,
      "filename": "4bf9c066-5edc-448d-81be-93ad868ba7a4_0.png",
      "itemName": "Restrooms",
      "category": "Community",
      "isApplicable": false
    },
    {
      "uid": 26,
      "filename": "4bf9c066-5edc-448d-81be-93ad868ba7a4_2.png",
      "itemName": "Restrooms",
      "category": "Community",
      "isApplicable": false
    },
    {
      "uid": 27,
      "filename": "4bf9c066-5edc-448d-81be-93ad868ba7a4_3.png",
      "itemName": "Restrooms",
      "category": "Community",
      "isApplicable": true
    },
    {
      "uid": 28,
      "filename": "5c65b86e-6b44-42b8-b170-61213efa3f39.png",
      "itemName": "Restrooms",
      "category": "Community",
      "isApplicable": false
    },
    {
      "uid": 29,
      "filename": "ed8ed872-4b3b-419b-a19e-803c0acd6406_2.png",
      "itemName": "Baseball Field",
      "category": "Sports",
      "isApplicable": true
    },
    {
      "uid": 30,
      "filename": "5e9dd324-ec30-4248-aacc-dc92ab95381f_1.png",
      "itemName": "Outdoor Swimming Pool",
      "category": "Sports",
      "isApplicable": false
    },
    {
      "uid": 31,
      "filename": "7973c8cd-28bd-40ba-be51-b4e28125b245_0.png",
      "itemName": "Outdoor Swimming Pool",
      "category": "Sports",
      "isApplicable": true
    },
    {
      "uid": 32,
      "filename": "4dacc210-e84f-4ef6-9375-81224e8d2dc5_1.png",
      "itemName": "Tennis Court",
      "category": "Sports",
      "isApplicable": false
    },
    {
      "uid": 33,
      "filename": "78afaeef-f707-4d52-967b-7125d7ab6306_0.png",
      "itemName": "Tennis Court",
      "category": "Sports",
      "isApplicable": false
    },
    {
      "uid": 34,
      "filename": "95e37817-c373-4e0c-a31e-5038c579a185.png",
      "itemName": "Tennis Court",
      "category": "Sports",
      "isApplicable": false
    },
    {
      "uid": 35,
      "filename": "7c63f67d-9a19-4793-8d34-0f54e70cca31_1.png",
      "itemName": "VolleyBall Court",
      "category": "Sports",
      "isApplicable": true
    },
    {
      "uid": 36,
      "filename": "fbee9931-8b20-4b72-a245-0f494577287d_3.png",
      "itemName": "Splash Pad",
      "category": "Family",
      "isApplicable": true
    },
    {
      "uid": 37,
      "filename": "dbdec2fd-2bde-405a-9a66-4455e42b5a5c_0.png",
      "itemName": "Tennis Court",
      "category": "Sports",
      "isApplicable": true
    },
    {
      "uid": 38,
      "filename": "c7b118d0-437f-4f7f-b0d9-331d1f4179af_0.png",
      "itemName": "Tennis Court",
      "category": "Sports",
      "isApplicable": false
    },
    {
      "uid": 39,
      "filename": "c7b118d0-437f-4f7f-b0d9-331d1f4179af_2.png",
      "itemName": "Tennis Court",
      "category": "Sports",
      "isApplicable": false
    },
    {
      "uid": 40,
      "filename": "7029f6f9-ffff-4865-9152-4004d0d8453e_1.png",
      "itemName": "Amphitheater",
      "category": "Community",
      "isApplicable": true
    },
    {
      "uid": 41,
      "filename": "e70f4c5d-3782-463d-88a1-eb7031f42a4e_0.png",
      "itemName": "Community Farm",
      "category": "Community",
      "isApplicable": true
    },
    {
      "uid": 42,
      "filename": "da3a5dec-d33e-4931-a1b8-fb526efe6741_0.png",
      "itemName": "Community Garden",
      "category": "Community",
      "isApplicable": false
    },
    {
      "uid": 43,
      "filename": "da3a5dec-d33e-4931-a1b8-fb526efe6741_2.png",
      "itemName": "Community Garden",
      "category": "Community",
      "isApplicable": true
    },
    {
      "uid": 44,
      "filename": "da3a5dec-d33e-4931-a1b8-fb526efe6741_3.png",
      "itemName": "Community Garden",
      "category": "Community",
      "isApplicable": false
    },
    {
      "uid": 45,
      "filename": "4a3d8029-6345-4891-ac06-7d8b39b80379_0.png",
      "itemName": "Concession Stand",
      "category": "Community",
      "isApplicable": false
    },
    {
      "uid": 46,
      "filename": "4a3d8029-6345-4891-ac06-7d8b39b80379_1.png",
      "itemName": "Concession Stand",
      "category": "Community",
      "isApplicable": false
    }
  ]